import { t } from '@lingui/macro';

export const moreInfoLabel = (): string => t`More info`;
export const genericError = (): string => t`Oops! Something went wrong.`;
